import {createRef} from 'react'
import ReactComponent from '../app/ReactComponent'
import {Button, Col, Flex, Image, Row} from 'antd'
import gsap from 'gsap/all'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {$t, _$t} from '../app/index'

// IMAGES
import withUsIcon from '../gfx/iceland-with-us-ico.png'
import onYourOwnIcon from '../gfx/iceland-on-your-own-ico.png'
import camperImage from '../gfx/DJI_01652@small.jpg'
import portraitJirkaKomorousImage from '../gfx/jirkakomorous.jpg'
import landscapeImage from '../gfx/landscape-770136941.jpg'
import GParallax from '../components/helpers/GParallax'
import GAddClassOnScreenEnter from '../components/helpers/GAddClassOnScreenEnter'
import {MagneticElementsController} from '@toon.rombaut/magnetic-elements'
import ContactSection from '../components/parts/ContactSection'
import {Link} from 'react-router-dom'
import {MouseScroll} from '../components/layout/MouseScroll'
import SplitTextToSpans from '../components/helpers/SplitTextToSpans'
import AnimatedTitle from '../components/parts/HomepageMainTitle'

gsap.registerPlugin(ScrollTrigger)

export default class HomePage extends ReactComponent {
  mag_element = null

  state = {
    ready: false,
    loading: true,
    _: {}
  }

  constructor(props) {
    super(props)

    this.mainTitleRef = createRef()
    this.homepageHeroSectionRef = createRef()
  }

  async componentDidMount() {
    this.scrollToTop()
    this.$app.$theme('dark')

    this.mag_element = new MagneticElementsController({
      triggerArea: 128,
      magneticForce: 0.08,
      interpolationFactor: 0.4
    })

    // GSAP animations
    await this.updateState({
      _: {
        section_intro_text: await _$t('section_intro_text'),
        section_about_text: await _$t('section_about_text')
      },
      ready: true
    })
  }

  componentWillUnmount() {
    this.mag_element.destroy()

  }

  render() {
    return (
      <>
        <section id="hero" ref={this.homepageHeroSectionRef} className="homepage-hero fullsize ta-center">
          <GParallax speed={-3} options={{y: 0}} scrollTrigger={{start: 'top top'}} className="homepage-hero-background"></GParallax>
          <Flex align="center" justify="center" style={{height: '100%', minHeight: '90vh'}}>
            <div className="container">

              <h1 ref={this.mainTitleRef} className="main-title">
                <AnimatedTitle><$t _="homepage_title" ready={this.state.ready}/></AnimatedTitle>
              </h1>
              <h2 className="main-subtitle">
                <$t _="homepage_subtitle"/>
              </h2>

              <Flex justify="center" className="flex-res">

                <GParallax speed={1} scrollTrigger={{start: 'top 36%'}}>
                  <div className="hey" data-glow="true">
                    <div data-glow="true"></div>
                    <div className="card-blurred">

                      <div className="card-content">

                        <Image src={withUsIcon} preview={false} className="icon"/>

                        <h3 className="title">
                          <$t _="iceland_on_your_own"/>
                        </h3>
                        <p className="text">
                          <$t _="iceland_on_your_own_subtitle"/>
                        </p>
                        <br/>
                        <Link to="/online-guide">
                          <Button type="primary">
                            <$t _="online_guide"/>
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </GParallax>

                <GParallax speed={1} scrollTrigger={{start: 'top 36%'}}>
                  <div className="hey" data-glow="true">
                    <div data-glow="true"></div>
                    <div className="card-blurred">
                      <div className="card-content">

                        <Image src={onYourOwnIcon} preview={false} className="icon"/>


                        <h3 className="title">
                          <$t _="iceland_with_us"/>
                        </h3>
                        <p className="text">
                          <$t _="iceland_with_us_subtitle"/>
                        </p>
                        <br/>
                        <Link to="/events">
                          <Button type="primary">
                            <$t _="book_trip"/>
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </GParallax>

              </Flex>
            </div>
            {/*<div>
              <MouseScroll onClick={() => {
                console.log('test')
                document.querySelector('#introduction').scrollIntoView({behavior: 'smooth'})

              }}/>
            </div>*/}
          </Flex>

          <br/>
          <br/>
          <br/>

          <div className="hero-gradient-bottom"></div>

        </section>

        <section id="introduction" className="section-about fullsize">
          <Flex align="center" justify="center" style={{height: '100%'}}>
            <div className="silencer">
              <div className="container wide">
                <Row gutter={48} justify="space-evenly" flex="">

                  <Col xs={24} sm={24} md={8}>
                    <GParallax speed={2}>
                      <div className="image-wrapper">
                        <Image src={camperImage} preview={false}/>
                      </div>
                    </GParallax>
                  </Col>

                  <Col xs={0} sm={0} md={2}></Col>

                  <Col xs={24} sm={24} md={14}>

                    <GAddClassOnScreenEnter>
                      <p className="section-about-text">
                        <SplitTextToSpans>{this.state._.section_intro_text || null}</SplitTextToSpans>
                      </p>
                    </GAddClassOnScreenEnter>

                    <GParallax speed={12}>
                      <h2 id="motto-headline" className="text-grad-reverse h1"><$t _="motto" /></h2>
                    </GParallax>
                  </Col>

                </Row>
              </div>
            </div>
          </Flex>
        </section>

        <br/>

        <section id="why-with-us" className="fullwidth">

          <GParallax speed={-3} className="fullwidth-background">
            <Image src={landscapeImage} preview={false}/>
          </GParallax>

          <div className="hero-gradient-top"></div>
          <div className="hero-gradient-bottom"></div>

          <div className="container centered wide va-margin">

            <Row align="stretch" justify="space-evenly" gutter={[48, 48]}>
              <Col span={24}>
                <GParallax speed={0.5}>
                  <h2 className="h1 ta-center mb-3"><span className="_grey-primary-text"><$t _="section_why_with_us_headline"/></span></h2>
                </GParallax>
              </Col>

              <Col xs={24} sm={12} md={12} lg={6}>


                  <div className="card-blurred ta-center">
                    <div className="card-content">
                      <span className="h1 dib fs-3x text-grad mt-2 mb-1">1.</span>
                      {/*<Image src={withUsIcon} preview={false} className="icon mb-2"/>*/}
                      <h5 className="mt-0">
                        <$t _="section_why_with_us_tile1_title"/>
                      </h5>
                      <p className="_grey-primary-text">
                        <$t _="section_why_with_us_tile1_content"/>
                      </p>
                    </div>
                  </div>



              </Col>

              <Col xs={24} sm={12} md={12} lg={6}>


                  <div className="card-blurred ta-center">
                    <div className="card-content">
                      <span className="h1 dib fs-3x text-grad mt-2 mb-1">2.</span>
                      <h5 className="mt-0">
                        <$t _="section_why_with_us_tile2_title"/>
                      </h5>
                      <p className="_grey-primary-text">
                        <$t _="section_why_with_us_tile2_content"/>
                      </p>
                    </div>
                  </div>

              </Col>

              <Col xs={24} sm={12} md={12} lg={6}>


                  <div className="card-blurred ta-center">
                    <div className="card-content">
                      <span className="h1 dib fs-3x text-grad mt-2 mb-1">3.</span>
                      <h5 className="mt-0">
                        <$t _="section_why_with_us_tile3_title"/>
                      </h5>
                      <p className="_grey-primary-text">
                        <$t _="section_why_with_us_tile3_content"/>
                      </p>
                    </div>
                  </div>
              </Col>

              <Col xs={24} sm={12} md={12} lg={6}>


                  <div data-glow></div>
                  <div className="card-blurred ta-center" style={{height: "100%"}}>
                    <div className="card-content">
                      <span className="h1 dib fs-3x text-grad mt-2 mb-1">4.</span>
                      <h5 className="mt-0">
                        <$t _="section_why_with_us_tile4_title"/>
                      </h5>
                      <p className="_grey-primary-text">
                        <$t _="section_why_with_us_tile4_content"/>
                      </p>
                    </div>
                  </div>

              </Col>

            </Row>

          </div>
        </section>

        <section id="about" className="section-about fullsize">
          <Flex align="center" justify="center" style={{height: '100%'}}>

            <div className="container">
              <Row gutter={48} justify="space-evenly">

                <Col xs={24} sm={24} md={{span: 8, order: 3}}>
                  <GParallax speed={3}>
                    <div className="image-wrapper">
                      <Image src={portraitJirkaKomorousImage} preview={false}/>
                    </div>
                  </GParallax>
                </Col>

                <Col xs={24} sm={24} md={14}>
                  <GAddClassOnScreenEnter>
                    <h1 className="ta-right"><span className="text-grad"><$t _="section_about_title"/></span></h1>
                    <p className="section-about-text ta-right mt-4">
                      <SplitTextToSpans>{this.state._.section_about_text || null}</SplitTextToSpans>

                    </p>
                  </GAddClassOnScreenEnter>
                  <div className="ta-right mt-4">
                    <Link to="/who-we-are">
                      <Button type="primary" size="large">
                        <$t _="more_about_us"/>
                      </Button>
                    </Link>
                  </div>
                </Col>

                <Col xs={0} sm={0} md={1}></Col>

              </Row>
            </div>
          </Flex>
        </section>

        <ContactSection/>

      </>
    )
  }
}